import type { RetailMediaSponsoredValue } from '../ga4Tracking/types';

export const getRetailMediaSponsoredValue = ({
  isSponsored,
  sku,
}: {
  isSponsored?: boolean;
  sku?: string | null;
}): RetailMediaSponsoredValue => {
  if (!isSponsored) {
    return 'false';
  }

  return sku ? 'true-original' : 'true-display';
};
